import type { MyCollection } from '@dmp/api/Collection/Collection.api.types';
import type { StateCreator } from 'zustand';

export type CollectionState = {
  collections: MyCollection[];
  isFetchingCollections: boolean;
  collectionTotal: number;
  collectionPageSize: number;
  collectionCurrentPage: number;
};

export const initialDownloadRequestsState: CollectionState = {
  collections: [],
  isFetchingCollections: false,
  collectionTotal: 0,
  collectionPageSize: 10,
  collectionCurrentPage: 1,
};

export const createCollectionSlice: StateCreator<CollectionState> = () => initialDownloadRequestsState;
